import { useState, useEffect } from 'react';
import { LockClosedIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../components/mobile/BottomNav';
import { useTranslations } from '../hooks/useTranslations';
import sub1en from '../assets/sub/Silver/Forex/1_-_What_is_Forex_en.vtt';
import sub1ru from '../assets/sub/Silver/Forex/1_-_What_is_Forex_ru.vtt';
import sub2en from '../assets/sub/Silver/Forex/2_-_Players_on_the_Forex_Market_en.vtt';
import sub2ru from '../assets/sub/Silver/Forex/2_-_Players_on_the_Forex_Market_ru.vtt';
import sub3en from '../assets/sub/Silver/Forex/3_-_A_Forex_Chart_en.vtt';
import sub3ru from '../assets/sub/Silver/Forex/3_-_A_Forex_Chart_ru.vtt';
import sub4en from '../assets/sub/Silver/Forex/4_-_Base_and_Quoted_Currencies_en.vtt';
import sub4ru from '../assets/sub/Silver/Forex/4_-_Base_and_Quoted_Currencies_ru.vtt';
import sub5en from '../assets/sub/Silver/Forex/5_-_Bulls_and_Bears_en.vtt';
import sub5ru from '../assets/sub/Silver/Forex/5_-_Bulls_and_Bears_ru.vtt';
import sub6en from '../assets/sub/Silver/Forex/6_-_Short_Selling_en.vtt';
import sub6ru from '../assets/sub/Silver/Forex/6_-_Short_Selling_ru.vtt';
import sub7en from '../assets/sub/Silver/Forex/7_-_Forex_Brokers_en.vtt';
import sub7ru from '../assets/sub/Silver/Forex/7_-_Forex_Brokers_ru.vtt';
import sub8en from '../assets/sub/Silver/Forex/8_-_Ask_and_Bid_Prices_en.vtt';
import sub8ru from '../assets/sub/Silver/Forex/8_-_Ask_and_Bid_Prices_ru.vtt';
import sub9en from '../assets/sub/Silver/Forex/9_-_What_is_Spread_en.vtt';
import sub9ru from '../assets/sub/Silver/Forex/9_-_What_is_Spread_ru.vtt';
import sub10en from '../assets/sub/Silver/Forex/10_-_Pips_and_Points_en.vtt';
import sub10ru from '../assets/sub/Silver/Forex/10_-_Pips_and_Points_ru.vtt';
import sub11en from '../assets/sub/Silver/Forex/11_-_5-Digit_Quotations_en.vtt';
import sub11ru from '../assets/sub/Silver/Forex/11_-_5-Digit_Quotations_ru.vtt';
import sub12en from '../assets/sub/Silver/Forex/12_-_What_is_a_Lot_en.vtt';
import sub12ru from '../assets/sub/Silver/Forex/12_-_What_is_a_Lot_ru.vtt';
import sub13en from '../assets/sub/Silver/Forex/13_-_What_is_Leverage_en.vtt';
import sub13ru from '../assets/sub/Silver/Forex/13_-_What_is_Leverage_ru.vtt';
import sub14en from '../assets/sub/Silver/Forex/14_-_Equity_and_Margin_en.vtt';
import sub14ru from '../assets/sub/Silver/Forex/14_-_Equity_and_Margin_ru.vtt';
import sub15en from '../assets/sub/Silver/Forex/15_-_What_is_a_StopLoss_en.vtt';
import sub15ru from '../assets/sub/Silver/Forex/15_-_What_is_a_StopLoss_ru.vtt';
import sub16en from '../assets/sub/Silver/Forex/16_-_Order_Types_-_Buy_Sell_BuyStop_SellStop_BuyLimit_SellLimit_en.vtt';
import sub16ru from '../assets/sub/Silver/Forex/16_-_Order_Types_-_Buy_Sell_BuyStop_SellStop_BuyLimit_SellLimit_ru.vtt';
import sub17en from '../assets/sub/Silver/Forex/17_-_Three_main_types_of_Analysis_en.vtt';
import sub17ru from '../assets/sub/Silver/Forex/17_-_Three_main_types_of_Analysis_ru.vtt';
import sub18en from '../assets/sub/Silver/Forex/18_-_Fundamental_Analysis_en.vtt';
import sub18ru from '../assets/sub/Silver/Forex/18_-_Fundamental_Analysis_ru.vtt';
import sub19en from '../assets/sub/Silver/Forex/19_-_Technical_Analysis_en.vtt';
import sub19ru from '../assets/sub/Silver/Forex/19_-_Technical_Analysis_ru.vtt';
import sub20en from '../assets/sub/Silver/Forex/20_-_Sentiment_Analysis_en.vtt';
import sub20ru from '../assets/sub/Silver/Forex/20_-_Sentiment_Analysis_ru.vtt';
import sub21en from '../assets/sub/Silver/Forex/21_-_What_you_will_get_from_this_section_en.vtt';
import sub21ru from '../assets/sub/Silver/Forex/21_-_What_you_will_get_from_this_section_ru.vtt';
import sub22en from '../assets/sub/Silver/Forex/22_-_Trends_and_Flats_en.vtt';
import sub22ru from '../assets/sub/Silver/Forex/22_-_Trends_and_Flats_ru.vtt';
import sub23en from '../assets/sub/Silver/Forex/23_-_Support_and_Resistance_Levels_en.vtt';
import sub23ru from '../assets/sub/Silver/Forex/23_-_Support_and_Resistance_Levels_ru.vtt';
import sub24en from '../assets/sub/Silver/Forex/24_-_Channels_en.vtt';
import sub24ru from '../assets/sub/Silver/Forex/24_-_Channels_ru.vtt';
import sub25en from '../assets/sub/Silver/Forex/25_-_Triangle_Pattern_en.vtt';
import sub25ru from '../assets/sub/Silver/Forex/25_-_Triangle_Pattern_ru.vtt';
import sub26en from '../assets/sub/Silver/Forex/26_-_Indicators_en.vtt';
import sub26ru from '../assets/sub/Silver/Forex/26_-_Indicators_ru.vtt';
import sub27en from '../assets/sub/Silver/Forex/27_-_Moving_Average_Indicator_en.vtt';
import sub27ru from '../assets/sub/Silver/Forex/27_-_Moving_Average_Indicator_ru.vtt';
import sub28en from '../assets/sub/Silver/Forex/28_-_Forex_Robots_and_Algorithmic_Trading_en.vtt';
import sub28ru from '../assets/sub/Silver/Forex/28_-_Forex_Robots_and_Algorithmic_Trading_ru.vtt';
import sub29en from '../assets/sub/Silver/Forex/29_-_How_to_calculate_Pip_Value_en.vtt';
import sub29ru from '../assets/sub/Silver/Forex/29_-_How_to_calculate_Pip_Value_ru.vtt';
import sub30en from '../assets/sub/Silver/Forex/30_-_How_to_calculate_Forex_Risks_en.vtt';
import sub30ru from '../assets/sub/Silver/Forex/30_-_How_to_calculate_Forex_Risks_ru.vtt';

function ForexVideoLessons() {
  const { t } = useTranslations();
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const navigate = useNavigate();

  const videoLessons = [
    {
      name: '1_-_What_is_Forex.mp4',
      title: t('forexVideoLessons.lessons.0.title'),
      subtitles: { en: sub1en, ru: sub1ru }
    },
    {
      name: '2_-_Players_on_the_Forex_Market.mp4',
      title: t('forexVideoLessons.lessons.1.title'),
      subtitles: { en: sub2en, ru: sub2ru }
    },
    {
      name: '3_-_A_Forex_Chart.mp4',
      title: t('forexVideoLessons.lessons.2.title'),
      subtitles: { en: sub3en, ru: sub3ru }
    },
    {
      name: '4_-_Base_and_Quoted_Currencies.mp4',
      title: t('forexVideoLessons.lessons.3.title'),
      subtitles: { en: sub4en, ru: sub4ru }
    },
    {
      name: '5_-_Bulls_and_Bears.mp4',
      title: t('forexVideoLessons.lessons.4.title'),
      subtitles: { en: sub5en, ru: sub5ru }
    },
    {
      name: '6_-_Short_Selling.mp4',
      title: t('forexVideoLessons.lessons.5.title'),
      subtitles: { en: sub6en, ru: sub6ru }
    },
    {
      name: '7_-_Forex_Brokers.mp4',
      title: t('forexVideoLessons.lessons.6.title'),
      subtitles: { en: sub7en, ru: sub7ru }
    },
    {
      name: '8_-_Ask_and_Bid_Prices.mp4',
      title: t('forexVideoLessons.lessons.7.title'),
      subtitles: { en: sub8en, ru: sub8ru }
    },
    {
      name: '9_-_What_is_Spread.mp4',
      title: t('forexVideoLessons.lessons.8.title'),
      subtitles: { en: sub9en, ru: sub9ru }
    },
    {
      name: '10_-_Pips_and_Points.mp4',
      title: t('forexVideoLessons.lessons.9.title'),
      subtitles: { en: sub10en, ru: sub10ru }
    },
    {
      name: '11_-_5-Digit_Quotations.mp4',
      title: t('forexVideoLessons.lessons.10.title'),
      subtitles: { en: sub11en, ru: sub11ru }
    },
    {
      name: '12_-_What_is_a_Lot.mp4',
      title: t('forexVideoLessons.lessons.11.title'),
      subtitles: { en: sub12en, ru: sub12ru }
    },
    {
      name: '13_-_What_is_Leverage.mp4',
      title: t('forexVideoLessons.lessons.12.title'),
      subtitles: { en: sub13en, ru: sub13ru }
    },
    {
      name: '14_-_Equity_and_Margin.mp4',
      title: t('forexVideoLessons.lessons.13.title'),
      subtitles: { en: sub14en, ru: sub14ru }
    },
    {
      name: '15_-_What_is_a_StopLoss.mp4',
      title: t('forexVideoLessons.lessons.14.title'),
      subtitles: { en: sub15en, ru: sub15ru }
    },
    {
      name: '16_-_Order_Types_-_Buy_Sell_BuyStop_SellStop_BuyLimit_SellLimit.mp4',
      title: t('forexVideoLessons.lessons.15.title'),
      subtitles: { en: sub16en, ru: sub16ru }
    },
    {
      name: '17_-_Three_main_types_of_Analysis.mp4',
      title: t('forexVideoLessons.lessons.16.title'),
      subtitles: { en: sub17en, ru: sub17ru }
    },
    {
      name: '18_-_Fundamental_Analysis.mp4',
      title: t('forexVideoLessons.lessons.17.title'),
      subtitles: { en: sub18en, ru: sub18ru }
    },
    {
      name: '19_-_Technical_Analysis.mp4',
      title: t('forexVideoLessons.lessons.18.title'),
      subtitles: { en: sub19en, ru: sub19ru }
    },
    {
      name: '20_-_Sentiment_Analysis.mp4',
      title: t('forexVideoLessons.lessons.19.title'),
      subtitles: { en: sub20en, ru: sub20ru }
    },
    {
      name: '21_-_What_you_will_get_from_this_section.mp4',
      title: t('forexVideoLessons.lessons.20.title'),
      subtitles: { en: sub21en, ru: sub21ru }
    },
    {
      name: '22_-_Trends_and_Flats.mp4',
      title: t('forexVideoLessons.lessons.21.title'),
      subtitles: { en: sub22en, ru: sub22ru }
    },
    {
      name: '23_-_Support_and_Resistance_Levels.mp4',
      title: t('forexVideoLessons.lessons.22.title'),
      subtitles: { en: sub23en, ru: sub23ru }
    },
    {
      name: '24_-_Channels.mp4',
      title: t('forexVideoLessons.lessons.23.title'),
      subtitles: { en: sub24en, ru: sub24ru }
    },
    {
      name: '25_-_Triangle_Pattern.mp4',
      title: t('forexVideoLessons.lessons.24.title'),
      subtitles: { en: sub25en, ru: sub25ru }
    },
    {
      name: '26_-_Indicators.mp4',
      title: t('forexVideoLessons.lessons.25.title'),
      subtitles: { en: sub26en, ru: sub26ru }
    },
    {
      name: '27_-_Moving_Average_Indicator.mp4',
      title: t('forexVideoLessons.lessons.26.title'),
      subtitles: { en: sub27en, ru: sub27ru }
    },
    {
      name: '28_-_Forex_Robots_and_Algorithmic_Trading.mp4',
      title: t('forexVideoLessons.lessons.27.title'),
      subtitles: { en: sub28en, ru: sub28ru }
    },
    {
      name: '29_-_How_to_calculate_Pip_Value.mp4',
      title: t('forexVideoLessons.lessons.28.title'),
      subtitles: { en: sub29en, ru: sub29ru }
    },
    {
      name: '30_-_How_to_calculate_Forex_Risks.mp4',
      title: t('forexVideoLessons.lessons.29.title'),
      subtitles: { en: sub30en, ru: sub30ru }
    },
  ];

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsLoading(false);
        return;
      }
      try {
        const response = await fetch('https://api.maxprofitacademy.com/user', {
          method: 'GET',
          headers: { 'token': JSON.parse(token) }
        });
        const data = await response.json();
        if (data.status === 200) {
          setUserData(data.data);
        }
      } catch (error) {
        //
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const hasValidCourse = userData?.course && ['GOLD', 'SILVER', 'PLATINUM'].includes(userData.course.toUpperCase());

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        <span className="ml-3 text-gray-600">{t('forexVideoLessons.loading')}</span>
      </div>
    );
  }

  if (!hasValidCourse) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <LockClosedIcon className="h-16 w-16 text-gray-400 mb-4" />
        <h2 className="text-2xl font-bold mb-2">{t('forexVideoLessons.noAccess')}</h2>
        <p className="text-gray-600">{t('forexVideoLessons.noAccessSubtitle')}</p>
        <BottomNav />
      </div>
    );
  }

  const currentVideo = videoLessons[selectedIdx];

  return (
    <div className="min-h-screen pb-20">
      <div className="flex items-center mb-6 px-4 pt-6">
        <button onClick={() => navigate(-1)} className="flex items-center text-primary font-semibold hover:underline">
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          {t('forexVideoLessons.backToSections')}
        </button>
      </div>
      <div className="flex flex-col lg:flex-row gap-8 px-4">
        {/* Список уроков */}
        <div className="lg:w-1/3 w-full mb-4 lg:mb-0">
          <div className="bg-white rounded-2xl shadow-md p-4">
            <h2 className="text-lg font-bold mb-4">{t('forexVideoLessons.lessonsList')}</h2>
            <div className="flex flex-col gap-2 max-h-[70vh] overflow-y-auto">
              {videoLessons.map((video, idx) => (
                <button
                  key={video.name}
                  onClick={() => { setSelectedIdx(idx); setIsVideoLoading(true); }}
                  className={`text-left px-3 py-2 rounded-xl transition-colors flex items-center gap-2 ${
                    selectedIdx === idx ? 'bg-primary text-black font-bold' : 'hover:bg-gray-100 text-gray-800'
                  }`}
                >
                  <span className="font-mono w-6 text-right">{idx + 1}.</span>
                  <span className="truncate">{video.title}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        {/* Плеер и инфо */}
        <div className="flex-1 flex flex-col items-center">
          <div className="w-full bg-white rounded-2xl shadow-md p-4 flex flex-col items-center">
            <h1 className="text-2xl font-bold mb-4 text-center">{currentVideo.title}</h1>
            <div className="w-full bg-black rounded-2xl overflow-hidden aspect-video relative mb-6">
              <video
                key={currentVideo.name}
                controls
                className="w-full h-full"
                onLoadedData={() => setIsVideoLoading(false)}
              >
                <source src={`https://cdn.maxprofitacademy.com/silver/forex/${currentVideo.name}`} type="video/mp4" />
                {currentVideo.subtitles && (
                  <>
                    <track
                      label="Русский"
                      kind="subtitles"
                      srcLang="ru"
                      src={currentVideo.subtitles.ru}
                      default
                    />
                    <track
                      label="English"
                      kind="subtitles"
                      srcLang="en"
                      src={currentVideo.subtitles.en}
                    />
                  </>
                )}
                {t('forexVideoLessons.videoNotSupported')}
              </video>
              {isVideoLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/50">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
}

export default ForexVideoLessons; 